import * as React from 'react';
import { Linking } from 'react-native';
import { Heading, Box, HStack, VStack, Pressable } from 'native-base';

export const About = () => {
  return (
    <VStack alignItems={'start'} w={'100%'} mt={4}>
      <Box w="100%" h="50">
        <Pressable
          w={'100%'}
          text={'Support'}
          onPress={() =>
            Linking.openURL('https://www.ayblehealth.com/privacy-policy')
          }
        >
          <HStack
            w={'100%'}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Heading
              fontFamily={'body'}
              fontWeight={'bold'}
              size={'md'}
              underline
            >
              Privacy Policy
            </Heading>
          </HStack>
        </Pressable>
      </Box>
      <Box w="100%" h="50">
        <Pressable
          w={'100%'}
          onPress={() => Linking.openURL('https://www.ayblehealth.com/eula')}
        >
          <HStack
            w={'100%'}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Heading
              fontFamily={'body'}
              fontWeight={'bold'}
              size={'md'}
              underline
            >
              Terms & Conditions
            </Heading>
          </HStack>
        </Pressable>
      </Box>
    </VStack>
  );
};
